import { ArrowRight, Check, Handshake, PackageCheck, TrendingUp } from "lucide-react";
import { useTranslation } from "react-i18next";
import { StandalonePageShell } from "@/components/site/StandalonePageShell";
import { ADVANTAGES, DEALERSHIP_URL } from "@/constants/site";
import { Reveal } from "@/lib/motion";
import { useSiteContent } from "@/lib/useSiteContent";

const processIcons = [Handshake, PackageCheck, TrendingUp];

export default function DealershipPage() {
  const { t } = useTranslation();
  const home = useSiteContent("home");
  const contact = useSiteContent("contact");
  const dealers = useSiteContent("dealers");
  const steps = t("pages.dealership.steps", { returnObjects: true });

  return (
    <StandalonePageShell
      content={{ home, contact, dealers }}
      eyebrow={dealers.eyebrow || t("pages.dealership.eyebrow")}
      title={dealers.title || t("pages.dealership.title")}
      description={dealers.description || t("pages.dealership.description")}
    >
      <section data-testid="dealership-page" className="bg-surface px-5 py-20 sm:px-8 lg:py-28">
        <div className="mx-auto max-w-7xl">
          <div className="grid gap-4 md:grid-cols-3">
            {(Array.isArray(steps) ? steps : []).map((step, index) => {
              const Icon = processIcons[index] || Check;
              return <Reveal key={step.title} delay={index * 0.08}><article className="h-full rounded-[2rem] border border-detail bg-cream p-7 sm:p-8"><span className="grid h-12 w-12 place-items-center rounded-2xl bg-brand text-cream"><Icon className="h-5 w-5" /></span><span className="mt-8 block text-xs font-semibold tracking-[0.18em] text-brand">0{index + 1}</span><h2 className="mt-3 font-heading text-2xl font-bold text-ink">{step.title}</h2><p className="mt-3 leading-relaxed text-ink/65">{step.text}</p></article></Reveal>;
            })}
          </div>
          <div className="mt-10 grid gap-3 sm:grid-cols-2 lg:grid-cols-4">
            {ADVANTAGES.map((advantage) => <div key={advantage.title} className="rounded-2xl border border-detail bg-cream p-5"><p className="font-semibold text-ink">{advantage.title}</p><p className="mt-2 text-sm leading-relaxed text-ink/60">{advantage.text}</p></div>)}
          </div>
          <div className="mt-10 rounded-[2rem] bg-ink px-7 py-10 text-cream sm:px-10"><p className="max-w-2xl font-heading text-2xl font-bold">{t("pages.dealership.closing")}</p><a href={DEALERSHIP_URL} className="mt-7 inline-flex items-center gap-2 rounded-full bg-brand px-6 py-3.5 text-sm font-semibold transition hover:bg-brand2">{t("common.applyNow")} <ArrowRight className="h-4 w-4" /></a></div>
        </div>
      </section>
    </StandalonePageShell>
  );
}
